import React from 'react';
import { Global } from '@emotion/core';
import { Box, Flex, Icon, LoadingIndicator } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Portal from '@shared/v2/components/Portal';

const LoadingOverlay = ({ children }) => (
  <Portal selector="portal-root">
    <Global
      styles={{
        body: {
          overflow: 'hidden',
        },
      }}
    />
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      position="fixed"
      zIndex="popup"
      top="0"
      bottom="0"
      right="0"
      left="0"
      bg="white"
      pb="30"
      data-testid="LOADING-OVERLAY"
    >
      <Icon name="flightRight" color="primary" size={65} />
      <Box m="7" textAlign="center">
        {children}
      </Box>
      <LoadingIndicator color="greys.smoke" />
    </Flex>
  </Portal>
);

LoadingOverlay.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoadingOverlay;
